import React from "react";
import picture from "../images/register.jpg";

const Picture = () => (
  <div className="pictureLogin">
    <img width="95%" padding="1%" src={picture} alt="carrot field pic" />
  </div>
);

export default Picture;